import { useCarouselToggle } from '@/hooks/useCarouselToggle';
import { routes } from '@/routes/routes';
import { Link } from '@reach/router';
import clsx from 'clsx';
import * as React from 'react';
import { getMediaFullUrl } from '@/functions/getMediaFullUrl';
import { CarouselHeader } from '../carouselHeader/CarouselHeader';
import { Container } from '../container/Container';
import { LocalVideoWithControls } from '../localVideoWithControls/LocalVideoWithControls';
import * as styles from './TestimonialCarousel.module.scss';

const Item = ({
  isSelected,
  quote,
  name,
  position,
  years,
  onClick,
}: {
  isSelected: boolean;
  quote: string;
  name: string;
  position: string;
  years: string;
  onClick?(): void;
}) => (
  <button onClick={onClick} className={clsx(styles.carousel__item, isSelected && styles['carousel__item___active'])}>
    <p className={styles.carousel__quote}>"{quote}"</p>
    <p className={styles.carousel__descLine}>{name}</p>
    <p className={styles.carousel__descLine}>
      {position}, {years} years at Cochran
    </p>
  </button>
);

export type QuoteItem = {
  name?: string | null;
  quote?: string | null;
  yearsAtCompany?: string | null;
  position?: string | null;
  video?: { __typename?: 'STRAPI__MEDIA'; url?: string | null } | null;
};

export const TestimonialCarousel = ({ items, className }: { items: QuoteItem[]; className?: string }) => {
  const { activeItemIndex, handlePrevClick, handleNextClick, setActiveItemIndex } = useCarouselToggle(items.length);
  const selectedItem = items[activeItemIndex];

  return (
    <Container className={className}>
      <div className={styles.carousel}>
        <CarouselHeader>
          <CarouselHeader.Title>Life at Cochran</CarouselHeader.Title>
          <div className={styles.carousel__desktopOnly}>
            <Link to={routes.work} className={styles.carousel__btn}>
              Explore our culture
            </Link>
          </div>
          <CarouselHeader.Navigation
            onPrevClick={handlePrevClick}
            onNextClick={handleNextClick}
            className={styles.carousel__mobileNavigation}
          />
        </CarouselHeader>
        <div className={styles.carousel__inner}>
          <div className={clsx(styles.carousel__details, styles.carousel__desktopOnly)}>
            {items.map((item, i) => (
              <Item
                key={i}
                isSelected={i === activeItemIndex}
                quote={item.quote!}
                name={item.name!}
                position={item.position!}
                years={item.yearsAtCompany!}
                onClick={() => setActiveItemIndex(i)}
              />
            ))}
          </div>
          <LocalVideoWithControls
            className={styles.carousel__video}
            src={getMediaFullUrl(selectedItem.video?.url!)}
            activeItem={activeItemIndex}
          />
          <div className={clsx(styles.carousel__mobileBottom)}>
            <Item
              isSelected={false}
              quote={selectedItem.quote!}
              name={selectedItem.name!}
              position={selectedItem.position!}
              years={selectedItem.yearsAtCompany!}
            />
            <Link to={routes.work} className={styles.carousel__btn}>
              Explore our culture
            </Link>
          </div>
        </div>
      </div>
    </Container>
  );
};
